import Exposure from '../../utils/exposure';
import Util from '../../utils/util.js';
import PicUtils from '../../utils/pic-util';
import { getMad, getAd } from '../../utils/api';
import { MptcPlayer } from 'mptcfe-wap-player'
// 播放器相关逻辑
export default function (options) {
    var exposure = new Exposure();
    exposure.addListener();
    var videoIdName = 'videoPlayer';
    var videoPlayerElem = document.querySelector('#' + videoIdName);
    var videoPlayerWrapperElem = document.querySelector('.video-player-wrapper');
    var videoNextTip = document.querySelector('#videoNextTip');
    var videoHeader = document.querySelector('.video-header');
    var videoImgElem = document.querySelector('.video-content img');
    var UA = window.navigator.userAgent
    var isIOS = UA.match(/(iPad|iPhone|iPod)[\w\s]*;(?:[\w\s]+;)*[\w\s]+(?:iPad|iPhone|iPod)?\sOS\s([\d_\.]+)/i)
    var timer= null;
    var commentCount = options&&options.commentCount // 评论数
    const videoMaxHeight = 800;

    // 续播的相关参数
    const nextVideoTime = 5;
    const symboleType = {
        videoClick: 'videoClick',
        continuous: 'continuous'
    }
    var videoInfoList = [],
        nextCount = 0,
        isNextDuration = false,
        isNewVideoStart = true;
    var isFullScreen = false; // 是否是全屏状态
    var videoPlayer;
    // 是否发起广告请求
    var loadAd = true;
    // 是否展示广告
    var showAd = true;
    // 播中上报
    var isMonitor = true;
    var timeUrl = [];
    var videoAdParam, madAdConfig, adResource, monitorConfig;
    // 清除倒计时
    var clear;
    var mainVideoInfo = {
        videoInfoDTO : {
            videoId: cfgs && cfgs.videoId,
            duration: cfgs && cfgs.duration,
        },
        channelId: cfgs.channelId,
    }

    if (videoPlayerElem) {
        var queryVideoElemByLevel = function (level) {return videoPlayerElem.querySelector("[data-level = '" + level + "']");};

        var mainVideoElem = queryVideoElemByLevel(1) || queryVideoElemByLevel(0) || queryVideoElemByLevel(2) || queryVideoElemByLevel(3);
        var videoWidth = mainVideoElem.getAttribute('data-width');
        var videoHeight = mainVideoElem.getAttribute('data-height');
        var videoUrl = mainVideoElem.getAttribute('data-url');
        var videoPoster = mainVideoElem.getAttribute('data-thumbnail');
        // 视频清晰度：0 极速，1 标清，2 高清，3 超清
        var mainVideoObj = {
            id: cfgs.newsId,
            authorId: cfgs.authorId,
            cover: videoPoster,
            videoInfo: {
                videoUrl,
                height: videoHeight,
                width: videoWidth,
            }
        }

        let mainPicObj = PicUtils.setVideoPicUtil({
            width: videoWidth,
            height: videoHeight,
            cover: mainVideoObj.cover,
        })
        mainVideoObj.cover = mainPicObj.cover
        // 竖屏
        if (videoHeight > videoWidth && videoImgElem) {
            videoImgElem.style.width = `unset`
            videoImgElem.style.margin = `auto`
        }
        let mainHeight = getVideoHeight(mainVideoObj)
        setPlayerHeight(mainHeight)
        videoPlayerWrapperElem.style.height = mainHeight + 'px';
        videoImgElem.src = mainVideoObj.cover

        videoPlayerWrapperElem.querySelector('.video-content').addEventListener('click', () => {
            playVideo(mainVideoObj)
            setNextVideoHeight(mainVideoObj)
            setVideoPos(mainVideoElem.offsetTop)
            setNextTipPos(videoPlayerWrapperElem.offsetHeight)
            nextCount = 0
            // 初始请求点位信息
            if (cfgs && cfgs.videoId && cfgs.duration) {
                initVideoGetMad(mainVideoInfo)
            }
        })

        // 生成播放器
        if (videoUrl) {
                videoPlayer = new MptcPlayer(videoPlayerElem, {
                    src: videoUrl,
                    poster: mainVideoObj.cover,
                    titleShow: false,
                    infoShow: false,
                    videoHeight: videoHeight,
                    videoWidth: videoWidth,
                    fullScreen: true,
                    interactInfo: {
                        comments: commentCount, // 评论数
                        authorName: window.cfgs.authorName,
                        authorCover: window.cfgs.authorCover,
                        authorHomePage: `/media/${window.cfgs.authorId}`,
                    },
                    params: {
                        newsId: cfgs.newsId,
                        authorId: cfgs.authorId,
                    }
                })
                // 视频开始播放时，隐藏顶部导航logo
                videoPlayer.on('play', function () {
                    if (isNewVideoStart) {
                        isNewVideoStart = false;
                    }
                    videoHeader && (videoHeader.style.opacity = 0);
                    // 开播后可以展示下一个广告
                    setTimeout(() => {
                        showAd = true
                    }, 2000)
                });

                videoPlayer.on('timeupdate', function (time) {
                    let diffTime = time.duration - time.currentTime;
                    // 播中，如果有点位信息
                    if (madAdConfig && madAdConfig.points) {
                        for (var i = 0; i < madAdConfig.points.length; i++) {
                            // 对应时间请求广告信息
                            if ((time.currentTime > madAdConfig.points[i].t - madAdConfig.MadRequestStart && time.currentTime < madAdConfig.points[i].t - madAdConfig.MadRequestEnd) && loadAd == true) {
                                loadAd = false;
                                initVideoGetAd(videoAdParam, madAdConfig.points[i].inx);
                            }
                            // 对应时间展示广告
                            if (Math.floor(time.currentTime) == madAdConfig.points[i].t && showAd == true) {
                                if (adResource && adResource.ads && adResource.ads[0] && adResource.ads[0].ad && adResource.ads[0].ad[0] && adResource.ads[0].ad[0].creatives && adResource.ads[0].ad[0].creatives.video) {
                                    loadVideoAd(adResource)
                                    showAd = false;
                                }
                                // 空广告
                                var adConfig = adResource && adResource.ads && adResource.ads[0] && adResource.ads[0].ad && adResource.ads[0].ad[0]
                                if (adConfig && adConfig.adtype && adConfig.adtype == -1) {
                                    setTimeout(() => {
                                        loadAd = true
                                    }, madAdConfig && madAdConfig.IntervalTime * 1000)
                                    setTimeout(() => {
                                        showAd = true
                                    }, 3000)
                                }
                                // pv/av上报
                                for (var j = 0; j < (monitorConfig && monitorConfig.length); j++) {
                                    if (monitorConfig[j].event == 0 || monitorConfig[j].event == 1) {
                                        sendToReport(monitorConfig[j].url)
                                    }
                                    if (j == monitorConfig.length - 1 && showAd !== false) {
                                        showAd = false;
                                    }
                                }
                            }
                        }
                    }
                    // 此逻辑只走一次
                    if (!isNextDuration) {
                        let nextVideoObj = videoInfoList[nextCount];
                        if (diffTime !== 0 && diffTime < nextVideoTime && nextVideoObj) {
                            isNextDuration = true;
                            showNextTip(true,nextVideoObj);
                            // 播放下一条
                            if (window.sohuSpm && typeof window.sohuSpm.sendAction === 'function') {
                                window.sohuSpm.sendAction({
                                    acode: '8142',
                                });
                            }
                        }
                    } else {
                        // 相关回退等逻辑处理
                        if (diffTime >= nextVideoTime) {
                            isNextDuration = false;
                            showNextTip(false);
                        }
                    }
                });

                // 视频暂停和结束时，显示顶部导航logo
                videoPlayer.on('pause', function () {
                    videoHeader && (videoHeader.style.opacity = 1);
                });
                // 播放下一个
                videoPlayer.on('ended', function () {
                    playNextVideo()
                });
                // 全屏开启
                videoPlayer.on('fullScreenOpen',function() {
                    isFullScreen = true
                    document.querySelector('.top-header').style.display = 'none' //隐藏header
                })
                // 全屏关闭
                videoPlayer.on('fullScreenClose',function() {
                    isFullScreen = false
                    document.querySelector('.top-header').style.display = 'flex'
                    showNextTip(false)
                })
        }
        // 点击”下一条提示“
        videoNextTip.addEventListener('click',()=>{
            playNextVideo(true)
        })
        /******** 连播相关 *********/
        // 相关推荐加载数据触发此事件
        Util.eventBus.$on('videoFeedLoadData', onLoadData);
        function onLoadData(videoList) {
            let arr = [];
            let videoListLen = videoInfoList.length;
            if (videoList.length > 0) {
                videoList.forEach((video, index) => {
                    if (video.contentType === 4) {
                        video.position = videoListLen + index,
                        arr.push(video);
                    }
                });
                videoInfoList = [...videoInfoList, ...arr];
            }
        }
        // 播放下一个 true-强制播放下一个
        function playNextVideo(force=false) {
            let nextVideo = videoInfoList?.[nextCount]
            nextVideo && FeedNextVideo(nextVideo , symboleType.continuous);
            if(nextCount && !videoInfoList[nextCount]) {
                if(isFullScreen) videoPlayer.showFullScreenCloseBtn() // 全屏状态下，最后一个展示”退出全屏“
            }
            showNextTip(false);
            isNextDuration = false;
            isNewVideoStart = true;
            if(isFullScreen) {
                let isVertical = nextVideo?.videoInfo?.height > nextVideo?.videoInfo?.width || false
                window.sohuSpm?.sendAction({
                    acode: force?'10904':'10901',
                    clkParam: `p:${isVertical?1:0}`
                });
            }
        }
        // feed流播放下一个
        function FeedNextVideo (video, type) {
            let $nextVideoItem = document.querySelectorAll('#videoFeed .video-item')?.[video?.position],
                $nextVideoBox = $nextVideoItem?.querySelector('.video-box'),
                top = $nextVideoBox.offsetTop - 44,
                videoBoxH = $nextVideoBox.offsetHeight;
            video.spm = video.spm || Util.parseURL($nextVideoItem?.querySelector('.entry-a')?.getAttribute('href')).spm
            video.videoInfo.videoUrl = getVideoUrl(video).videoUrl
            playVideo(video)
            // 相关推荐流点击获取点位
            if (cfgs && cfgs.videoId && cfgs.duration) {
                initVideoGetMad(video)
            }
            setNextVideoHeight(video)
            setVideoPos(top) // 设置播放器位置
            setNextTipPos(top + videoBoxH)
            if (symboleType.continuous === type) {
                let scrolltop = top
                if (video?.position > 0) {
                    let $currentVideo = document.querySelectorAll('#videoFeed .video-box')[video?.position - 1]
                    scrolltop = top - $currentVideo.getBoundingClientRect().top
                }
                scrollTo(0, scrolltop)
            }

            nextCount++;
        }

        // 图片广告上报
        function sendToReport(url) {
            var img = new Image()
            img.src = url
            img.onerror = () => {}
        }

        // 初始化视频请求接口获取广告点位
        function initVideoGetMad(param) {
            var adDom = document.querySelector('#videoGod')
            var adWrapper = document.querySelector('#videoGodWrapper')
            adWrapper.pause()
            adDom.style.display = 'none'
            adWrapper.src = ''
            if (typeof clear == 'function') {
                clear()
            }
            adResource = undefined
            monitorConfig = undefined
            timeUrl = undefined
            var washParam = {
                spm: 'smwp.vd-land.ad',
                vid: param.videoInfoDTO && param.videoInfoDTO.videoId,
                du: param.videoInfoDTO && param.videoInfoDTO.duration,
                catecode: param.channelId,
            }
            getMad(washParam).then((res) => {
                videoAdParam = param;
                madAdConfig = res;
                loadAd = true;
                if (isIOS) {
                    var startBtn = document.querySelector('.ios-video-layer-wrapper')
                    startBtn.style.display = 'block'
                }
            }).catch((err) => {
                console.log(err)
            })
        }

        // 初始化视频请求接口获取广告
        function initVideoGetAd(param, index) {
            var washParam = {
                prot: 'json',
                protv: '1',
                pt: 'mad',
                adslotid: '90003',
                pageUrl: window.location.href,
                pageRefer: document.referrer,
                spm: 'smwp.vd-land.ad',
                vid: param.videoInfoDTO.videoId,
                du: param.videoInfoDTO.duration,
                catecode: param.channelId,
                timetag: new Date().getTime(),
                inx: index,
            }
            getAd(washParam).then((res) => {
                adResource = res;
                var adConfig = res && res.ads && res.ads[0] && res.ads[0].ad && res.ads[0].ad[0]
                if (adConfig) {
                    if (adConfig.event_monitor) {
                        if (adConfig.click_monitor) {
                            monitorConfig = adConfig.event_monitor.concat(adConfig.click_monitor)
                        } else {
                            monitorConfig = adConfig.event_monitor
                        }
                    } else {
                        if (adConfig.click_monitor) {
                            monitorConfig = adConfig.click_monitor
                        }
                    }
                }
                var videoInfo = adConfig && adConfig.creatives && adConfig.creatives.video
                var videoUrl = adConfig && adConfig.landing_url
                var top = videoPlayerElem.style.top
                var height = videoPlayerElem.style.height
                // 广告移到当前视频位置
                var adDom = document.querySelector('#videoGod')
                adDom.style.top = top
                adDom.style.height = height
                // 点击广告跳转
                adDom.addEventListener('click', function() {
                    // 点击上报
                    for (var i = 0; i < (monitorConfig && monitorConfig.length); i++) {
                        if (monitorConfig[i].event == 5) {
                            sendToReport(monitorConfig[i].url)
                        }
                    }
                    // 点击跳走，停止广告
                    var adWrapper = document.querySelector('#videoGodWrapper')
                    var adDom = document.querySelector('#videoGod')
                    if (adDom && adWrapper) {
                        adWrapper.pause()
                        adDom.style.display = 'none'
                        adWrapper.src = ''
                        adResource = undefined
                        monitorConfig = undefined
                        timeUrl = undefined
                        loadAd = true
                        if (isIOS) {
                            var startBtn = document.querySelector('.ios-video-layer-wrapper')
                            startBtn.style.display = 'block'
                        }
                        setTimeout(() => {
                            showAd = true
                        }, 2000)
                    }
                    setTimeout(() => {
                        window.location.href = videoUrl
                    }, 0)
                })

                if (isIOS) {
                    // 点击广告跳转
                    var adBtn = document.querySelector('.video-god-message')
                    adBtn.addEventListener('click', function() {
                        // 点击上报
                        for (var i = 0; i < (monitorConfig && monitorConfig.length); i++) {
                            if (monitorConfig[i].event == 5) {
                                sendToReport(that.monitorConfig[i].url)
                            }
                        }
                        // 点击跳走，停止广告
                        var adWrapper = document.querySelector('#videoGodWrapper')
                        var adDom = document.querySelector('#videoGod')
                        if (adDom && adWrapper) {
                            adWrapper.pause()
                            adDom.style.display = 'none'
                            adWrapper.src = ''
                            adResource = undefined
                            monitorConfig = undefined
                            timeUrl = undefined
                            loadAd = true
                            var startBtn = document.querySelector('.ios-video-layer-wrapper')
                            startBtn.style.display = 'block'
                            adWrapper.src = ''
                            setTimeout(() => {
                                showAd = true
                            }, 2000)
                        }
                        setTimeout(() => {
                            window.location.href = videoUrl
                        }, 0)
                    })
                }
                // 设置广告视频资源与样式
                var adWrapper = document.querySelector('#videoGodWrapper')
                if (videoInfo && videoInfo.height > videoInfo.width) {
                    adWrapper.style.height = '100%'
                } else {
                    adWrapper.style.width = '100%'
                }
                if (videoInfo && videoInfo.content) {
                    adWrapper.src = ''
                    adWrapper.src = videoInfo && videoInfo.content
                }
            }).catch((err) => {
                console.log(err)
            })
        }

        // 展示广告
        function loadVideoAd(res) {
            var adDom = document.querySelector('#videoGod')
            var adWrapper = document.querySelector('#videoGodWrapper')
            // flex布局居中
            adDom.style.display = 'flex'
            var videoDom = document.querySelector('.mptc-video')
            // 暂停原视频
            videoDom.pause()
            var durationDom = document.querySelector('.video-du')
            var countDom = document.querySelector('.video-count')
            var closeControl = document.querySelector('.close-control')
            var adConfig = res && res.ads && res.ads[0] && res.ads[0].ad && res.ads[0].ad[0] && res.ads[0].ad[0].creatives
            var du = adConfig && adConfig.video && adConfig.video.duration && Number(adConfig.video.duration)
            var count = 5
            countDom.style.display = 'inline-block'
            if (du == (adConfig && adConfig.video && adConfig.video.duration && Number(adConfig.video.duration))) {
                durationDom.innerHTML = du
            }
            countDom.innerHTML = 5 + 's 后'
            var duCountDown, countCountDown;
            // 播放广告
            if (isIOS) {
                var startBtn = document.querySelector('.ios-video-layer-wrapper')
                startBtn.addEventListener('click', function() {
                    event.stopPropagation();
                    adWrapper.play()
                })
            } else {
                adWrapper.play()
            }
            adWrapper.addEventListener('play', function() {
                if (isIOS) {
                    var startBtn = document.querySelector('.ios-video-layer-wrapper')
                    startBtn.style.display = 'none'
                }
                // 倒计时
                if (du == (adConfig && adConfig.video && adConfig.video.duration && Number(adConfig.video.duration))) {
                    duCountDown = setInterval(() => {
                        du--
                        durationDom.innerHTML = du
                    }, 1000)
                }
                if (count == 5) {
                    countCountDown = setInterval(() => {
                        count--
                        countDom.innerHTML = count + 's 后'
                    }, 1000)
                }
                clear = function() {
                    clearInterval(duCountDown)
                    clearInterval(countCountDown)
                }
            })
            adDom.addEventListener('click', function() {
                clearInterval(duCountDown)
                clearInterval(countCountDown)
            })
            if (isIOS) {
                var adBtn = document.querySelector('.video-god-message')
                adBtn.addEventListener('click', function() {
                    clearInterval(duCountDown)
                    clearInterval(countCountDown)
                })
            }
            adWrapper.addEventListener('timeupdate', function() {
                // 播中上报
                for (var i = 0; i < (monitorConfig && monitorConfig.length); i++) {
                    if (monitorConfig[i].event == 3) {
                        var hasUrl = false;
                        if (timeUrl && timeUrl.length == 0) {
                            timeUrl.push({
                                time: monitorConfig[i].time,
                                url: monitorConfig[i].url
                            })
                        }
                        for (var a = 0; a < (timeUrl && timeUrl.length); a++) {
                            if (((timeUrl[a] && timeUrl[a].time) == monitorConfig[i].time) && ((timeUrl[a] && timeUrl[a].url) == monitorConfig[i].url)) {
                                hasUrl = true;
                            }
                            if (a == timeUrl.length - 1 && !hasUrl) {
                                timeUrl.push({
                                    time: monitorConfig[i].time,
                                    url: monitorConfig[i].url
                                })
                            }
                        }
                        if (isMonitor == true) {
                            if (Math.floor(this.currentTime) == monitorConfig[i].time) {
                                for (var j = 0; j < (timeUrl && timeUrl.length); j++) {
                                    if (Math.floor(this.currentTime) == timeUrl[j].time) {
                                        sendToReport(timeUrl[j].url)
                                    }
                                    if (j == timeUrl.length - 1) {
                                        isMonitor = false
                                        setTimeout(() => {
                                            isMonitor = true
                                        }, 1000)
                                    }
                                }
                            }
                        }
                    }
                }
                if (du <= 0) {
                    clearInterval(duCountDown)
                }
                // 倒计时结束后隐藏倒计时控制，并能跳过广告
                if (count <= 0) {
                    clearInterval(countCountDown)
                    countDom.style.display = 'none'
                    closeControl.style.color = '#fff'
                    closeControl.onclick = function() {
                        event.stopPropagation()
                        clearInterval(duCountDown)
                        clearInterval(countCountDown)
                        adWrapper.pause()
                        adDom.style.display = 'none'
                        videoDom.play()
                        if (isIOS) {
                            var startBtn = document.querySelector('.ios-video-layer-wrapper')
                            startBtn.style.display = 'block'
                        }
                        adWrapper.src = ''
                        // 跳过上报
                        for (var i = 0; i < (monitorConfig && monitorConfig.length); i++) {
                            if (monitorConfig[i].event == 12) {
                                sendToReport(monitorConfig[i].url)
                            }
                        }
                        setTimeout(() => {
                            loadAd = true;
                        }, madAdConfig && madAdConfig.IntervalTime * 1000)
                        adResource = undefined;
                        monitorConfig = undefined;
                        timeUrl = []
                    }
                } else {
                    countDom.style.display = 'inline-block'
                    closeControl.style.color = '#ccc'
                    closeControl.onclick = function(){}
                }
            })
            adWrapper.addEventListener('pause', function() {
                clearInterval(duCountDown)
                clearInterval(countCountDown)
            })
            // 广告播放完毕
            adWrapper.addEventListener('ended', function() {
                clearInterval(duCountDown)
                clearInterval(countCountDown)
                adDom.style.display = 'none'
                if (isIOS) {
                    var startBtn = document.querySelector('.ios-video-layer-wrapper')
                    startBtn.style.display = 'block'
                }
                adWrapper.src = ''
                // 完播上报
                for (var i = 0; i < (monitorConfig && monitorConfig.length); i++) {
                    if (monitorConfig[i].event == 2) {
                        sendToReport(monitorConfig[i].url)
                    }
                }
                setTimeout(() => {
                    loadAd = true;
                }, madAdConfig && madAdConfig.IntervalTime * 1000)
                videoDom.play()
                adResource = undefined;
                monitorConfig = undefined;
                timeUrl = []
            }, false)
        }

        function playVideo (video) {
            videoPlayerElem.style.display = 'block'
            videoHeader && (videoHeader.style.opacity = 1);
            var adDom = document.querySelector('#videoGod')
            var adWrapper = document.querySelector('#videoGodWrapper')
            if (adDom && adWrapper) {
                adWrapper.pause()
                adDom.style.display = 'none'
            }
            // 下一条播放
            if (video) {
                videoPlayer.play({
                    src: video.videoInfo.videoUrl,
                    poster: video.videoInfo.cover,
                    fullScreen: true,
                    params: {
                        spm: video.spm,
                        newsId: video.id,
                        authorId: video.authorId,
                    },
                    interactInfo: {
                        comments: video.comments, // 评论数
                        authorName: video.authorName,
                        authorCover: video.authorCover,
                        authorHomePage: `/media/${video.authorId}`,
                    },
                });

            }
        }

        // 获取视频url
        function getVideoUrl(video) {
            let videoInfo = video.videoInfo
            if (!videoInfo) {
                return;
            }

            // 如果已存在videoUrl则无需转换
            if (video.videoInfo.videoUrl) { return video.videoInfo }

            let videoLevelMap = {};
            videoInfo.sofaInfo.forEach(video => {
                if (video) {
                    videoLevelMap[video.videoLevelId] = video;
                }
            });
            // 视频清晰度：0 极速，1 标清，2 高清，3 超清
           return videoLevelMap[1] || videoLevelMap[0] || videoLevelMap[2] || videoLevelMap[3];
        }

        // 即将播放下一个tip显示与隐藏
        function showNextTip(isShow,videoInfo={}) {
            const VideoWapDomList = document.querySelector('.mptc-video-wrapper')?.classList?.value

            if(VideoWapDomList.indexOf('video-wrapper-fullscreen') >= 0) { // 全屏样式
                if(videoInfo.id) {
                    let info = `即将播放下一个视频：${videoInfo.title}`
                    videoNextTip.classList = ['next-tip-fullscreen']
                    videoNextTip.style = ''
                    videoNextTip.innerHTML = `<div class="title">${info}</div><div class="icon"></div>`
                }
            }else { // 非全屏
                videoNextTip.classList = ['video-player-next-tip']
                videoNextTip.style.display = isShow ? 'block' : 'none'
                videoNextTip.innerHTML = '即将播放下一条'
            }
            
        }

        function setNextTipPos (top) { videoNextTip.style.top = top + 4 + 'px' }

        function setVideoPos (top){ videoPlayerElem.style.top = `${top}px` }

        function scrollTo (x, y) { window.scrollTo(x, y) }

        // 根据视频比例，设置播放器的高度, 不同视频的高度宽度适配
        function getVideoHeight (video) {
            let innerWidth = window.innerWidth,
                w = video.videoInfo.width,
                h = video.videoInfo.height;

            if (w && h) {
                let height = h*(innerWidth/w)
                height > videoMaxHeight && (height = videoMaxHeight)
                return height
            }
        }

        // 设置video的高度，由于视频播放器切换高度会变化
        function setNextVideoHeight(video) {
            setPlayerHeight(getVideoHeight(video));
        }

        Util.eventBus.$on('videoFeedClick', (currentCount) => {
            nextCount = currentCount
            showNextTip(false);
            FeedNextVideo(videoInfoList[currentCount], symboleType.videoClick)
        });

        // 当前播放的视频如果不在视口中，则暂停播放
        function scrollInit () {
            window.addEventListener('scroll', () => {
                 if(videoPlayer && !exposure.isExposure(videoPlayerElem)) {
                    videoPlayer.pause();
                    // 当前播放的广告如果不在视口中，则停止广告
                    var adWrapper = document.querySelector('#videoGodWrapper')
                    var adDom = document.querySelector('#videoGod')
                    if (adDom && adWrapper) {
                        adWrapper.pause()
                        adWrapper.src = ''
                        adDom.style.display = 'none'
                        if (isIOS) {
                            var startBtn = document.querySelector('.ios-video-layer-wrapper')
                            startBtn.style.display = 'block'
                        }
                        adResource = undefined
                        monitorConfig = undefined
                        timeUrl = []
                        loadAd = true
                        setTimeout(() => {
                            showAd = true
                        }, 2000)
                    }
                }
            })
        }
        scrollInit()

        // 当连播并屏幕宽度发生变化时对播放器位置进行重新定位
        initResize()

        // 设置播放器高度
        function setPlayerHeight (height) {
            if (videoPlayerElem && videoPlayerWrapperElem) { videoPlayerElem.style.height = height + 'px'; }
        }

        function initResize () {
            // 全屏播放视频后返回时，重新定位播放器的位置
            let eventType = (typeof window.orientation === 'number' && typeof window.onorientationchange === 'object') ? 'orientationchange' : 'resize';
            $(window).on(eventType, () => {
                if(timer) clearTimeout(timer);
                timer = setTimeout(() => {
                    if (nextCount === 0) { return }
                    let currentVideo = videoInfoList[nextCount - 1]
                    let $VideoBox = document.querySelectorAll('#videoFeed .video-item')[currentVideo.position].querySelector('.video-box'),
                        top = $VideoBox.offsetTop,
                        videoBoxH = $VideoBox.offsetHeight;
                    setVideoPos(top) // 设置播放器位置
                    setNextVideoHeight(currentVideo)
                    setNextTipPos(top + videoBoxH)
                }, 1000);
            });
        }
    }
}